/* KnowledgeCard.tsx generated by @compiled/babel-plugin v0.38.1 */
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["name", "size", "children", "containerStyles"];
import "./KnowledgeCard.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { cx } from '@atlaskit/css';
import { Box, Inline } from '@atlaskit/primitives/compiled';
import UFOSegment from '@atlaskit/react-ufo/segment';
var knowledgeCardStyles = {
  default: "_2rko12b0 _189ee4h9 _1dqonqa1 _1h6d1l7x",
  compact: "_ca0qutpp _u5f3utpp _19bvutpp _n3tdutpp",
  full: "_ca0qpxbi _u5f3pxbi _19bvpxbi _n3tdpxbi"
};
var defaultInlineProps = {
  alignBlock: 'center',
  grow: 'fill',
  space: 'space.050'
};
export var KnowledgeCard = function KnowledgeCard(_ref) {
  var name = _ref.name,
    size = _ref.size,
    children = _ref.children,
    containerStyles = _ref.containerStyles,
    inlineProps = _objectWithoutProperties(_ref, _excluded);
  var knowledgeCardProps = _objectSpread(_objectSpread({}, defaultInlineProps), inlineProps);
  return /*#__PURE__*/React.createElement(UFOSegment, {
    name: name
  }, /*#__PURE__*/React.createElement(Box, {
    as: "section"
  }, /*#__PURE__*/React.createElement(Inline, _extends({}, knowledgeCardProps, {
    xcss: containerStyles !== null && containerStyles !== void 0 ? containerStyles :
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    cx(knowledgeCardStyles.default, size === 'full' ? knowledgeCardStyles.full : knowledgeCardStyles.compact)
  }), children)));
};